import keyMirror from '../../util/keyMirror';

export default keyMirror('Editorial', [
    'LOAD_EDITORIAL_START',
    'LOAD_EDITORIAL_SUCCESS',
    'LOAD_EDITORIAL_FAIL'
]);
